import { ghostButton } from '../ui/Button';

/**
 * The PDF of an invoice or a quote.
 *
 * `/api/documents/:kind/:id` has served real, role-gated PDFs since M4. Nothing in the
 * frontend linked to it: the anchors were deleted along with the old UI in c4e1fd5, and
 * nobody noticed because no test can see a missing link. Meanwhile the invoice screen went
 * on telling people to "download the PDF and send it yourself" next to a button that did
 * not exist — which is worse than having no PDF at all, because it reads as broken software
 * rather than a missing feature.
 *
 * It is a plain <a>, not a fetch-and-blob: the browser already carries the session cookie,
 * already knows how to show a PDF, and already has a Save button in its viewer. `target`
 * opens it beside the app so the operator doesn't lose the invoice they were working on.
 */
export function DocumentLink({
  kind,
  id,
  label,
}: {
  kind: 'invoice' | 'quote';
  id: string;
  label?: string;
}) {
  return (
    <a
      href={`/api/documents/${kind}/${id}`}
      target="_blank"
      rel="noopener noreferrer"
      className={ghostButton}
    >
      {label ?? 'PDF'}
    </a>
  );
}
